import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import logo from '../assets/eurocas-logo.jpeg';
import GoogleSignInButton from '../components/GoogleSignInButton';

// Google Sign-In is the only login path in production. On localhost there's
// usually no REACT_APP_GOOGLE_CLIENT_ID configured, so fall back to the
// password form there instead of leaving the login page a dead end. The
// backend route and all account data are untouched either way — this only
// hides the form.
const SHOW_PASSWORD_LOGIN = ['localhost', '127.0.0.1'].includes(window.location.hostname);

const Login = () => {
  const { login, loginWithGoogle, notify } = useApp();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(identifier, password);
      navigate('/');
    } catch (err) {
      notify(err.message, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleGoogleCredential = useCallback(
    async (credential) => {
      try {
        await loginWithGoogle(credential);
        navigate('/');
      } catch (err) {
        notify(err.message, 'error');
      }
    },
    [loginWithGoogle, navigate, notify]
  );

  const handleGoogleError = useCallback((message) => notify(message, 'error'), [notify]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src={logo} alt="EUROCAS Career & Schooling Madurai" className="auth-logo" />
        <span className="navbar-product-tag" style={{ alignSelf: 'center' }} title="Language Management System">LMS</span>
        {SHOW_PASSWORD_LOGIN && <p className="auth-subtitle">Sign in with your email</p>}

        {SHOW_PASSWORD_LOGIN && (
          <form onSubmit={handleSubmit}>
            <label>
              Email
              <input type="text" value={identifier} onChange={(e) => setIdentifier(e.target.value)} required />
            </label>
            <label>
              Password
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </label>
            <button type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        )}

        {SHOW_PASSWORD_LOGIN && (
          <div className="google-signin-divider"><span>or</span></div>
        )}

        <GoogleSignInButton onCredential={handleGoogleCredential} onError={handleGoogleError} />
      </div>
    </div>
  );
};

export default Login;
